import React, { lazy } from "react";

const LazyManualUploads = lazy(() => import("./ManualUploads"));

const ManualUploads = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyManualUploads {...props} />;

export default ManualUploads;
